import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import RouterFile from './RouterFile.js';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterFile />
  </React.StrictMode>
);

reportWebVitals();
